/** @format */
'use strict';
import { Modal } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
class ModalMgr {
    showFlowModal(Component, title, handleOk, handleCancel, getResultCallback, restParams, containerId = '_rootModal') {
        let obj = {};
        let { onWaitOk = null, footer, ...otherParams } = (restParams || {});
        if (!document.getElementById(containerId)) {
            let _div = document.createElement('div');
            _div.setAttribute('id', containerId);
            document.body.append(_div);
        }
        const JSXE = React.cloneElement(Component, {
            ref(ref) {
                obj.model = ref;
            }
        });
        // 拦截footer
        let custom = {};
        if (footer === null) {
            custom.footer = null;
        }
        else if (Array.isArray(footer)) {
            footer = footer.map(item => {
                let { comp, event: eventName, callback, ...rProps } = item;
                return React.cloneElement(comp, {
                    [eventName]: e => callback(e, obj.model),
                    ...rProps
                });
            });
            custom.footer = footer;
        }
        else if (React.isValidElement(footer)) {
            footer = React.cloneElement(footer, {
                getModalInner: () => obj.model,
                ref(footRef) {
                    obj.footRef = footRef;
                }
            });
            custom.footer = footer;
        }
        return ReactDOM.render(<Modal maskClosable={false} style={{ display: 'table' }} className={'menu-modal' || restParams.className} visible={true} title={title || null} okText='确定' cancelText='取消' onOk={args => {
            if (!!onWaitOk) {
                onWaitOk(obj.model, args);
            }
            else {
                if (!(handleOk && handleOk(obj.model, args))) {
                    this.hideWorkModal(containerId);
                }
                else {
                    !!getResultCallback && getResultCallback(handleOk(obj.model, args));
                    this.hideWorkModal(containerId);
                }
            }
        }} onCancel={args => {
            if (!(handleCancel && handleCancel(obj.model, args))) {
                this.hideWorkModal(containerId);
            }
            else {
                !!getResultCallback && getResultCallback(handleCancel(obj.model, args));
                this.hideWorkModal(containerId);
            }
        }} {...custom} {...otherParams}>
        {JSXE}
      </Modal>, document.getElementById(containerId));
    }
    hideWorkModal(containerId = '_rootModal') {
        if (document.getElementById(containerId)) {
            ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
        }
    }
}
export default new ModalMgr();



// WEBPACK FOOTER //
// ./src/utils/ModalMgr.jsx